module.exports = __webpack_public_path__ + "024d482691121094cbe6adf6feaf5cb0.png";